import { render, staticRenderFns } from "./BusinessOrdersReport.vue?vue&type=template&id=aed0e820&scoped=true"
import script from "./BusinessOrdersReport.vue?vue&type=script&lang=js"
export * from "./BusinessOrdersReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed0e820",
  null
  
)

export default component.exports